import { autoserialize, autoserializeAs } from 'cerialize';

export class MiniDriver {
  @autoserialize
  driverId: number;

  @autoserialize
  claraPersonIdentifier: number;

  @autoserialize
  driverStatusName: string;

  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserializeAs(Date)
  timestamp: Date;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  preferred: boolean;

  @autoserialize
  username: string;
}
